import React, { Component } from 'react';
import PageHeader from './PageHeader';
import HorizontalBars from '../charts/HorizontalBars';
import RowTitle from '../charts/RowTitle';
import Reflection from './Reflection';

export default class StatementVariations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      limits: {
        'over': [{lowerLimit: 0, upperLimit: 5}],
        'under': [{lowerLimit: 0, upperLimit: 5}]
      }
    };
  }

  componentDidMount() {
    const { reportType, scoreDifferences, mergedAverageOfAnswersByRelationship } = this.props;
    let reviewersAnswerScores = {};
    if (reportType === 'User') {
      for (const questionID in mergedAverageOfAnswersByRelationship) {
        reviewersAnswerScores[questionID] = +mergedAverageOfAnswersByRelationship[questionID][0];
      }
    } else if (reportType === 'Comparison') {
      for (const questionID in mergedAverageOfAnswersByRelationship) {
        reviewersAnswerScores[questionID] = +mergedAverageOfAnswersByRelationship[questionID];
      }
    } else {
      reviewersAnswerScores = mergedAverageOfAnswersByRelationship;
    }
    const variationAnswerKeys = Object.keys(scoreDifferences).sort((a,b) => {
      return scoreDifferences[b] - scoreDifferences[a];
    })
    this.setState({
      variationAnswerKeys,
      reviewersAnswerScores
    })
  }

  componentDidUpdate(prevProps, prevState) {
    // when pdf export is requested, an initial re-render alters the page width to match the pdf, then calculates page break limits and re-renders back to normal width
    if (prevProps.layoutMode !== this.props.layoutMode) {
      if (this.props.layoutMode === 'pdfRecalculate') {
        let limits = {
          'over': [],
          'under': []
        };
        const updateLimits = (orderType) => {
          const { variationAnswerKeys } = this.state;
          const answerKeys = orderType === 'over' ? [...variationAnswerKeys] : [...variationAnswerKeys].reverse()
          let count = 0;
          let lowerLimit = 0;
          let upperLimit;
          // accounts for intro text on first page
          let spaceAvailable = orderType === 'over' ? 380 : 520;
          answerKeys.forEach((questionID, i) => {
            if (i < 5) {
              // get row height and check if it will fit, if not update limits and reset count
              let rowHeight = 0;
              const chartRow = this[`statementRow${orderType}-${questionID}`];
              if (chartRow) {
                rowHeight = chartRow.offsetHeight + 1;
              }
              if ((count + rowHeight) < spaceAvailable) {
                count += rowHeight;
              } else {
                upperLimit = i;
                limits[orderType].push({lowerLimit, upperLimit});
                lowerLimit = i;
                count = rowHeight;
                spaceAvailable = 520;
              }
            }
          })
          limits[orderType].push({lowerLimit, upperLimit: 5});
        }
        updateLimits('over')
        updateLimits('under')
        this.setState({ limits });
        this.props.updateStatementVariationsPDFExportPreRenderStatus();
      }
    }
  }

  render() {
    const { reportType, generateGraph, scoreDifferences, questionDetails, mergedAverageOfAnswersByRelationship, userIndividualAnswers, pdfRequested, layoutMode } = this.props;
    const { variationAnswerKeys, limits, reviewersAnswerScores } = this.state;
    const userColour = '#0051ff';
    const reviewerColour = '#F563B9';
    const reviewerTypes = ['Reviewers', 'Self'];
    const orderTypes = ['over', 'under'];
    const checkVariationValidity = (orderType, score) => {
      if (orderType === 'over') {
        return score > 0;
      } else {
        return score < 0;
      }
    }
    return (generateGraph && limits) && (
      <>
        {orderTypes.map(orderType => {
          let answerKeys = [];
          if (variationAnswerKeys) {
            answerKeys = [...variationAnswerKeys]
            if (orderType !== 'over') {
              answerKeys = [...variationAnswerKeys].reverse();
            }
          }
          return (
            limits[orderType].map((limitsObj, i) => {
              const { lowerLimit, upperLimit } = limitsObj;
              return (
                <div key={orderType + i} className='bg-white page-break user-report__content'>
                  <PageHeader
                    h2Class='mt4'
                    h2Text='Part 1: '
                    strong='Step 4'
                    h3Text='Statements: greatest variations'
                    line={true}
                  />

                  {(orderType === 'over' && i === 0) && (
                    reportType === 'Group' ? (
                      <p>
                        Here is a list of the statements that had the most significant variation between the collective self-review and the collective
                        reviewer’s ratings. You will find both over and under-ratings listed.
                      </p>
                    ) : (
                      <>
                        <p>
                          Here is a list of the statements that had the most significant variation between your self-review and your reviewer’s ratings. You
                          will find both over and under-ratings listed.
                        </p>
                        <p>
                          Statements which you over-rated in comparison to your colleagues may indicate that you perceive that you display these
                          behaviours/actions more frequently than others see them.
                        </p>
                        <p>
                          Statements which you under-rated in comparison your colleagues, may indicate that you display these behaviours/actions more frequently
                          than you initially perceived.
                        </p>
                      </>
                    )
                  )}

                  <div 
                    className='bb b--light-gray mv5'
                    style={{ width: layoutMode === 'pdfRecalculate' ? '158mm' : ''}}
                  >
                    <p>
                      <strong>Statements which you have {orderType}-rated the most{i > 0 ? ' (continued)' : ''}</strong>
                    </p>

                    {answerKeys && (
                      answerKeys.map((key, index) => {
                        return ((scoreDifferences && checkVariationValidity(orderType, scoreDifferences[key])) && ((index >= lowerLimit) && index < upperLimit)) ? (
                          <div 
                            key={key}
                            ref={(questionRow) => {
                              this[`statementRow${orderType}-${key}`] = questionRow
                            }}
                            className='w-100 flex bt b--light-gray'
                          >
                            <RowTitle containerClass='w-40 pr2' title={questionDetails[key].questionTitle} />
                    
                            {reportType !== 'Self' && (
                              <div className='w-20'>
                                {reviewerTypes.map(type => {
                                  return (
                                    <p key={type} style={{ color: type === 'Self' ? userColour : reviewerColour }}>
                                      <strong>{type}</strong>
                                    </p>
                                  )
                                })}
                              </div>
                            )}
                            
                            <HorizontalBars 
                              reportType={reportType} 
                              containerClass='w-40' 
                              pClass='flex' 
                              selfAnswerScore={userIndividualAnswers[key].toFixed(1)} 
                              reviewersAnswerScore={reviewersAnswerScores[key].toFixed(1)} 
                              userColour={userColour} 
                              reviewerColour={reviewerColour} 
                              variations={true}
                              orderType={orderType}
                            />
                          </div>
                        ) : (
                          (!checkVariationValidity(orderType, scoreDifferences[key]) && index === 0) && (
                            <div key={key}>
                              <h4>There are no statements where you have {orderType}-rated in comparison to the feedback you have received</h4>
                            </div>
                          )
                        )
                      })
                    )}
                  </div>
                </div>
              )
            })
          )
        })}
        {reportType !== 'Group' && (
          <Reflection step='4' subTitle='Statements: greatest variations' />
        )}
      </>
    )
  }
}
